// extracted by mini-css-extract-plugin
module.exports = {"container":"PricingPlans_container__2q9YZ","list":"PricingPlans_list__2dotI"};